import React from 'react';
import { Flex } from '../Flex';
import { buildCols } from '../../utils';
import { ArticleSectionTitle } from '../ArticleSectionTitle';
import { HoverLink } from '../HoverLink/HoverLink';
import { Box } from '../../wag-react/next-components/box';
import { ColumnList } from '../../wag-react/components/ColumnList';
type RelatedArticle = {
  title: string;
  link: string;
};
export type RelatedArticlesValue = RelatedArticle[];
type Props = {
  value: RelatedArticlesValue;
};
const mapToLinkElement = (items: RelatedArticle[]) => items.map(item => <Box key={item.title} pb="24px">
    <HoverLink href={item.link} fontSize={['14px', '14px', '16px']} fontWeight="bold" style={{
    wordBreak: 'break-word',
    textDecoration: 'underline'
  }}>
      {item.title}
    </HoverLink>
  </Box>);
export const RelatedArticles = ({
  value
}: Props) => {
  const items = mapToLinkElement(value)?.slice(0, 12);
  const mobileItems = buildCols(1, items);
  const tabletItems = buildCols(2, items);
  const desktopItems = buildCols(3, items);
  return <Flex flexDirection="column" overflow="hidden" data-sentry-element="Flex" data-sentry-component="RelatedArticles" data-sentry-source-file="index.tsx">
      <ArticleSectionTitle mt={0} data-sentry-element="ArticleSectionTitle" data-sentry-source-file="index.tsx">
        Most popular symptom guides
      </ArticleSectionTitle>
      <ColumnList display={['flex', 'none', 'none']} cols={mobileItems} gridGap="20px" width={1} data-sentry-element="ColumnList" data-sentry-source-file="index.tsx" />

      <ColumnList display={['none', 'flex', 'none']} cols={tabletItems} gridGap="20px" width={1} data-sentry-element="ColumnList" data-sentry-source-file="index.tsx" />

      <ColumnList display={['none', 'none', 'flex']} cols={desktopItems} width={1} gridGap="20px" data-sentry-element="ColumnList" data-sentry-source-file="index.tsx" />
    </Flex>;
};
export type RelatedArticlesProps = Props;